import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete, Radio, RadioGroup, FormControlLabel, FormLabel,
    Typography
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import styled, { cutDates, inputStyles, stockNumber, inputNumbersmall, inputStyle11 } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectFirm, selectItems, selectParty } from '../Selectors/Master/ItemSelectors';
import axios from 'axios';
import Dropdown from '../FieldsComponents/Dropdown';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';
import PreviewIcon from '@mui/icons-material/Preview';
import DeleteIcon from '@mui/icons-material/Delete';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { adminStkInwMenu, StkInwMenu, UStkInwMenu } from '../TitleList';
import RadioComponent from '../FieldsComponents/RadioComponent';
import { insertUserStkRtInwEntry } from '../../Store/PHPSlice/Return';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { fetchLocationData } from '../../Store/PHPSlice/LocationApi';
import { selectLocations } from '../Selectors/Master/OutwardSelectors';

const UserReturnInwardEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        stk_type: 'Bill Wise',
        firmId: '',
        partyId: '',
        schlId: '',
        memo: '',
        item: '',
        size: '',
        col: '',
        qnty: '',
        saleRt: '',
        purRt: '',
        totQty: '0',
        totprate: '0',
        totsrate: '0',
        totdisrate: '0',
        totdisrate2: '0',
        totQty2: '0',
        totdisamt: '0',
        totdisamt2: '0',
        totprate2: '0',
        totsrate2: '0',
        totamt: '0',
        totamt2: '0',
        freight_ch: '0',
        other_ch: '0',
        grandtot: '',
        gst_type: 'no',
        gst: '5',
        igst: '0',
        cgst: '0',
        sgst: '0',
        state_type: '',
        discnt_type: 'percent',
        discnt_amt: '',
        discnt_val: '0',
        netamt: '',
        billNo: '',
        userId: userdata?.ID
    });
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        // Add more mappings if needed
    };
    const [userData, setUserData] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [multiItems, setMultiItems] = useState([]);
    const [billList, setBillList] = useState([]);
    const [schlList, setSchlList] = useState([]);
    const [items, setItems] = useState([]);
    const [selectData, setSelectData] = useState([]);
    const [activeMenu, setActiveMenu] = useState(StkInwMenu);
    const dispatch = useDispatch();

    const itemList = useSelector(selectItems);
    const firmlist = useSelector(selectFirm);
    const allschls = useSelector(selectLocations);

    useEffect(() => {
        dispatch(fetchItemData());
        dispatch(fetchCompanyData());
        dispatch(fetchLocationData());
         fetchBillNosSchlwise();
        fetchUserStkMemo();
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        const user = sessionStorage.getItem('user');
        if (user) {
            setUserData(JSON.parse(user));
        }
    }, []);

    useEffect(() => {
        if (!userdata) return;

        if (userdata?.udata && userdata?.schlwise === false) {
            const val = userdata?.ID;
           // fetchBillNosSchlwise({ userId: val });
            

        }

        if (userdata?.pageIds?.length > 0 && userdata?.role !== '1') {
            const pid = userdata?.pageIds?.find(item => item === 1);
            if (pid === 1 && userdata?.role === '3') {
                setActiveMenu(adminStkInwMenu);
            } else if (userdata?.role === '2') {
                setActiveMenu(UStkInwMenu);
            } else {
                setActiveMenu(StkInwMenu);
            }

            const selectpid = userdata?.pageIds?.filter(item => item === 1 || item === 2);
            if (selectpid?.length > 0) {
                const data = {
                    uid: userdata?.ID,
                    pageId: selectpid
                };
                fetchPageAssignSchools(data);
            }
        }
    }, []);

    const options_gst = [
        { value: 'yes', label: 'School' },
        { value: 'no', label: 'Godown' },
    ];

    const handleRadioChange = (event) => {
        const { name, value } = event.target;
        // setFormData({
        //     // ...formData,
        //     // [event.target.name]: event.target.value,
        //     ...formData,
        //     [name]: value,   // updates ordType
        //      schlId: event.target.value === 'no' ? '' : formData.schlId,
        //     billNo: event.target.value === 'no' ? '' : formData.billNo,
        // });
         setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });


        if (event.target.value === 'no') {
            setBillList([]); // Clear bill list when switching to Godown
        }

        if (event.target.value === 'yes') {
            const update_gross = parseInt(formData.totamt, 10) - parseInt(formData.discnt_amt, 10) + parseInt(formData.freight_ch, 10) + parseInt(formData.other_ch, 10);
            let igst = 0, cgst = 0, sgst = 0, gst = 5;
            let cal_grand = Math.round(parseFloat(update_gross) * (parseFloat(gst) / 100));
            if (formData.state_type == '1') {
                igst = cal_grand;
            } else {
                const half_grand = (cal_grand / 2).toFixed(2);
                cgst = half_grand;
                sgst = half_grand;
            }
            let final_grand_tot = Math.round(parseInt(update_gross, 10) + parseInt(cal_grand, 10));

            setFormData(prevFormData => ({
                ...prevFormData,
                grandtot: update_gross,
                igst: igst || 0,
                cgst: cgst || 0,
                sgst: sgst || 0,
                netamt: final_grand_tot,
                gst: gst
            }));
        }
        if (event.target.value === 'no') {
            const gross_tot = parseInt(formData.totamt, 10) - parseInt(formData.discnt_amt, 10);
            const update_gross = parseInt(gross_tot, 10) + parseInt(formData.freight_ch, 10) + parseInt(formData.other_ch, 10);
            let igst = 0, cgst = 0, sgst = 0;
            let cal_grand = Math.round(parseFloat(update_gross) * (parseFloat(formData.gst) / 100));
            if (formData.state_type == '1') {
                igst = 0;
            } else {
                cgst = 0;
                sgst = 0;
            }
            let final_grand_tot = 0;

            setFormData(prevFormData => ({
                ...prevFormData,
                grandtot: update_gross,
                igst: igst || 0,
                cgst: cgst || 0,
                sgst: sgst || 0,
                netamt: final_grand_tot,
                gst: '0'
            }));
        }
    };

    const fields2 = [
        { label: 'Total Return Qty', name: 'totQty', type: 'readOnly' },
        { label: 'Discount %', name: 'discnt_val', type: 'readOnly' },
        { label: 'Total Return Rate', name: 'totsrate', type: 'readOnly' },
        { label: 'Total Discount Rate', name: 'totdisrate', type: 'readOnly' },
        { label: 'Total Amount', name: 'totdisamt', type: 'readOnly' },
    ];

    const isDesktop = useMediaQuery('(min-width:768px)');

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleViewClick = (form) => {
        const url = `/user-return-stock-inward-view?form=${encodeURIComponent(JSON.stringify(form))}`;
        window.open(url, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'item':
                if (value) {
                    const selectInfo = items?.find(val => val.ID === value);
                    const filterData = items?.filter((val) => val.ID !== value);
                    setTableData(prev => [...prev, selectInfo]);
                    setItems(filterData);
                }
                break;
            case 'billNo':
                if (value) {
                    fetchItems(value);
                } else {
                    setTableData([]);
                    setFormData(prev => ({
                        ...prev,
                        totQty: '0',
                        totQty2: ''
                    }));
                }
                break;
            case 'schlId':
                if (value && formData.gst_type === 'yes') {
                    fetchBillNosSchlwise({ schlId: value });
                }
                break;
            case 'discnt_val':
                if (value) {
                    let totalAmount = parseFloat(formData.totamt);
                    let discnt_amt, grandtot;
                    let other_ch = formData.other_ch !== '' ? parseFloat(formData.other_ch) : 0;
                    let freight_ch = formData.freight_ch !== '' ? parseFloat(formData.freight_ch) : 0;
                    if (formData.discnt_type == 'percent') {
                        discnt_amt = Math.round(totalAmount / parseFloat(value));
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    } else if (formData.discnt_type == 'rupees') {
                        discnt_amt = parseFloat(value);
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    }

                    let igst = 0, cgst = 0, sgst = 0;
                    let cal_grand = Math.round(parseFloat(grandtot) * (parseFloat(formData.gst) / 100));
                    if (formData.state_type == '1') {
                        igst = cal_grand;
                    } else {
                        const half_grand = (cal_grand / 2).toFixed(2);
                        cgst = half_grand;
                        sgst = half_grand;
                    }
                    let final_grand_tot = Math.round(parseInt(grandtot, 10) + parseInt(cal_grand, 10));
                    setFormData(prev => ({
                        ...prev,
                        discnt_amt: discnt_amt,
                        grandtot: grandtot,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: final_grand_tot
                    }));
                }
                break;
            default:
                break;
        }
    };

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleChange = (index, field, value) => {
        const updatedData = [...tableData];

        if (field === 'qty') {
            const prevQty = parseFloat(updatedData[index][field] || 0);
            const newQty = parseFloat(value || 0);
            const prate = parseFloat(updatedData[index].prate || 0);
            const amt = newQty * prate;
            updatedData[index][field] = newQty;
            updatedData[index].amt = amt;
            setTableData(updatedData);
            setFormData(prev => ({
                ...prev,
                totQty: parseFloat(prev.totQty) - prevQty + newQty,
                totQty2: parseFloat(prev.totQty2) - prevQty + newQty,
            }));
        }

        if (field === 'prate') {
            const prevPrate = parseFloat(updatedData[index][field] || 0);
            const newPrate = parseFloat(value || 0);
            const qty = parseFloat(updatedData[index].qty || 0);
            const amt = qty * newPrate;
            updatedData[index][field] = newPrate;
            updatedData[index].amt = amt;
            setTableData(updatedData);
            const totprate = multiItems?.reduce((acc, sum) => acc + parseFloat(sum.totprate), 0);
            setFormData(prev => ({
                ...prev,
                totprate: parseFloat(prev.totprate) - prevPrate + newPrate,
                totprate2: parseFloat(prev.totprate2) - prevPrate + newPrate,
            }));
        }

        if (field === 'srate') {
            const prevSrate = parseFloat(updatedData[index][field] || 0);
            const newQSrate = parseFloat(value || 0);
            updatedData[index][field] = newQSrate;
            setTableData(updatedData);
            const totsrate = multiItems?.reduce((acc, sum) => acc + parseFloat(sum.totsrate), 0);
            setFormData(prev => ({
                ...prev,
                totsrate: parseFloat(prev.totsrate) - prevSrate + newQSrate,
                totsrate2: parseFloat(prev.totsrate2) - prevSrate + newQSrate,
            }));
        }

        if (field === 'color') {
            updatedData[index][field] = value;
            setTableData(updatedData);
        }

        if (field === 'salerate') {
            updatedData[index][field] = value;
            setTableData(updatedData);
        }
        if (field === 'issqty') {
            const bqty = parseFloat(updatedData[index].bqty);
            const issqty = parseFloat(value);

            if (issqty <= bqty) {
                const balqty = bqty - issqty;
                updatedData[index][field] = value;
                updatedData[index].balqty = balqty;
                setTableData(updatedData);
            } else {
                alert("Issued quantity cannot be greater than balance quantity.");
            }
        }
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    const fetchPageAssignSchools = async (id) => {
        const { uid, pageId } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getUserwisePageIdSchools&uid=${uid}&pageId=${pageId}`);
            setSchlList(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchUserStkMemo = async () => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getUserRTStkInwardMemo`);
            const memos = response?.data?.data;
            setFormData(prev => ({
                ...prev,
                memo: memos?.memo
            }));
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchBillNosSchlwise = async () => {
        try {
            
            const response = await axios.get(`${baseUrl}?apicall=fetchRTBillNo`);
                console.log("res=>",response?.data?.data);
                setBillList(response?.data?.data);
            
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchItems = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getReturnInwardInfo&sId=${id}`);
            setSelectData(response?.data);
            setTableData(response.data.info);
            const val = response.data.data;

            const totsrate = response?.data?.info?.reduce((acc, sum) => acc + parseFloat(sum.srate), 0);
            const totdisrate = response?.data?.info?.reduce((acc, sum) => acc + parseFloat(sum.disrate), 0);
            const totdisamt = response?.data?.info?.reduce((acc, sum) => acc + parseFloat(sum.disamt), 0);

            const itemid = response?.data?.info?.length > 0 ? response?.data?.info[0]?.itemId : '0';
            setFormData(prev => ({
                ...prev,
                totQty: parseFloat(prev.totQty) + parseFloat(val.totissqty),
                totQty2: parseFloat(val.totissqty),
                discnt_amt: val.discnt_amt,
                discnt_val: val.discnt_val,
                netamt: val.netamt,
                grandtot: val.netamt,
                item: itemid,
                firmId: val.firmId,
                totdisamt2: totdisamt,
                totsrate2: totsrate,
                totdisrate2: totdisrate
            }));
            const filterBills = billList?.filter((val) => val.ID !== id);
            setBillList(filterBills);
        } catch (error) {
            console.error('Error fetching info list:', error);
            setTableData([]);
        }
    };

    const dropdownOrdType = [
        {
            label: 'Firm',
            id: 'firmId',
            options: firmlist?.data || [],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        ...(formData.gst_type === 'yes' ? [{
            label: 'School',
            id: 'schlId',
            options: userdata?.role !== '1' ? schlList : allschls?.data || [],
            value: formData.schlId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlId', value: newValue ? newValue.ID : '' } }, 'schlId'),
            getOptionLabel: (option) => option.schlcd || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        }] : []),
        {
            label: 'Transfer Bill No',
            id: 'billNo',
            options: billList || [],
            value: formData.billNo,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'billNo', value: newValue ? newValue.ID : '' } }, 'billNo'),
            getOptionLabel: (option) => option.billNo || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        }
    ];

    const handleMultiItems = () => {
        const itemnm = itemList?.data?.find(val => val.ID === formData.item)?.itemNm;
        const totsalerate = tableData?.reduce((acc, sum) => acc + parseFloat(sum.srate), 0);
        const totdisrate = tableData?.reduce((acc, sum) => acc + parseFloat(sum.disrate), 0);
        const totdisamt = tableData?.reduce((acc, sum) => acc + parseFloat(sum.disamt), 0);
        const data = {
            info: tableData,
            itemNm: itemnm,
            itemId: formData.item,
            totqty: formData.totQty2,
            adsaleid: formData.billNo,
            totsrate: totsalerate,
            totdisrate: totdisrate,
            totdisamt: totdisamt
        };
        console.log("adsaleid=>",formData.billNo);
        setMultiItems(prev => [...prev, data]);
        setTableData([]);
        setFormData(prev => ({
            ...prev,
            totQty2: '',
            billNo: '',
            totsrate: parseFloat(prev.totsrate) + totsalerate,
            totdisrate: parseFloat(prev.totdisrate) + totdisrate,
            totdisamt: parseFloat(prev.totdisamt) + totdisamt,
            totdisamt2: '0',
            totsrate2: '0',
            totdisrate2: '0'
        }));
    };

    const handleCheckboxChange = (index) => {
        setSelectedRows(prevSelectedRows => {
            const newSelectedRows = new Set(prevSelectedRows);
            if (newSelectedRows.has(index)) {
                newSelectedRows.delete(index);
            } else {
                newSelectedRows.add(index);
            }
            return newSelectedRows;
        });
    };

    const handleRemoveSelected = () => {
        const filterData = multiItems?.filter((_, index) => selectedRows.has(index));
        const totqty = filterData?.reduce((acc, sum) => acc + parseFloat(sum.totqty), 0);
        const totsrate = filterData?.reduce((acc, sum) => acc + parseFloat(sum.totsrate), 0);
        const totdisrate = filterData?.reduce((acc, sum) => acc + parseFloat(sum.totdisrate), 0);
        const totdisamt = filterData?.reduce((acc, sum) => acc + parseFloat(sum.totdisamt), 0);
        setFormData(prev => ({
            ...prev,
            totQty: parseFloat(prev.totQty) - parseFloat(totqty),
            totQty2: '0',
            totsrate: parseFloat(prev.totsrate) - parseFloat(totsrate),
            totsrate2: '0',
            totdisrate: parseFloat(prev.totdisrate) - parseFloat(totdisrate),
            totdisrate2: '0',
            totdisamt: parseFloat(prev.totdisamt) - totdisamt,
            totdisamt2: '0'
        }));

        setMultiItems(prevFormArray =>
            prevFormArray.filter((_, index) => !selectedRows.has(index))
        );
        setSelectedRows(new Set());
    };

    function convertIntoOneObject(formData, multiItems) {
        const data = {
            dt: formData.dt,
            memo: formData.memo,
            firmId: formData.firmId,
            party: formData.partyId,
            schlId: formData.schlId,
            multiItems: multiItems,
            discnt_val: formData.discnt_val,
            totqty: formData.totQty,
            totsrate: formData.totsrate,
            totdisrate: formData.totdisrate,
            totdisamt: formData.totdisamt,
            userId: formData.userId,
            stk_type: formData.stk_type,
            adsid: formData.billNo,
            gst_type:formData.gst_type
        };
        return data;
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (formData.firmId === '') {
            alert('Please Select Firm');
            return;
        }

        if (formData.gst_type === 'yes' && formData.schlId === '') {
            alert('Please Select School');
            return;
        }
       // console.log("gst_type=>",formData.gst_type);
        const finalObj = convertIntoOneObject(formData, multiItems);
        //console.log("finalobj=>",finalObj);
        dispatch(insertUserStkRtInwEntry(finalObj))
            .unwrap()
            .then((result) => {
                console.log('POST request successful!', result);
                alert("Return Stock Inward Details Added Successfully.....");
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error while making POST request:', error);
            });
    };

    return (
        <>
            <Titlebar data={activeMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Transfer Stock Inward Entry</h2>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                <RadioComponent
                                    label='Stock Inward Accept For:'
                                    name='gst_type'
                                    value={formData.gst_type}
                                    options={options_gst}
                                    onChange={handleRadioChange}
                                    isDesktop={true}
                                />

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Transfer Inward Memo No', name: 'memo', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {dropdownOrdType?.map((drop) => (
                                    <Dropdown
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}
                                    />
                                ))}

                                {fields2.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {Array.isArray(tableData) && tableData.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow className='tbl-row'>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Item</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Size</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Color</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Stock Qty</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Sale Rate</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Discount Rate</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Amt</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableData.length > 0
                                                        ? tableData?.map((form, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.itemNm}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.size}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.color}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.bqty}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.srate}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.disrate}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.disamt}</TableCell>
                                                            </TableRow>
                                                        ))
                                                        : ''}
                                                    <TableRow>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'></TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'></TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'></TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>Total</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{formData.totQty2}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{formData.totsrate2}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{formData.totdisrate2}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{formData.totdisamt2}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                        <Grid item xs={12} textAlign="center" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                            <Button variant="contained" color="primary" onClick={handleMultiItems}>Add</Button>
                                            
                                        </Grid>
                                    </>
                                }

                                <Button variant="contained" color="primary" onClick={handleRemoveSelected}>Delete</Button>

                                <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow className='tbl-row'>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Select.</TableCell>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Item</TableCell>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Total Return Qty</TableCell>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Total Return Rate</TableCell>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Total Discount Rate</TableCell>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Total Amount</TableCell>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>View</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {multiItems.length > 0
                                                ? multiItems?.map((form, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                            <Checkbox
                                                                checked={selectedRows?.has(index)}
                                                                onChange={() => handleCheckboxChange(index)}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.itemNm}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.totqty}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.totsrate}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.totdisrate}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.totdisamt}</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                            <PreviewIcon className='cursor-pointer' onClick={() => handleViewClick(form)} />
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                                : ''}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default UserReturnInwardEntry;